/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import { Crate } from '@piwikpro/platform';
import HttpCrate from '@piwikpro/http-crate';
import ConfirmationCrate from '@piwikpro/confirmation-crate';
import NotificationCrate from '@piwikpro/notification-crate';
import userGroups from './redux';
import { UserGroups } from './UserGroups';

@Crate({
  name: 'UserGroupsCrate',
  imports: [
    HttpCrate,
    ConfirmationCrate,
    NotificationCrate,
  ],
  reducers: {
    userGroups: userGroups,
  },
  services: [
    { name: 'userGroups', provide: UserGroups },
  ],
})
export class UserGroupsCrate {}
